module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sc-basic-widget:total":"Всего"},"en":{"sc-basic-widget:total":"Total"}}')
  delete Component.options._Ctor
}
